module.exports = __webpack_public_path__ + "static/media/andaman&nicobar.73b06e09.png";